import React, { useMemo, useState } from 'react';
import { SmsIcon } from '../sms/SmsMarks';

interface PublicInboxLinkProps {
  path: string | null;
  compact?: boolean;
}

function absoluteUrl(path: string): string {
  if (typeof window === 'undefined') return path;
  return new URL(path, window.location.origin).toString();
}

const PublicInboxLink: React.FC<PublicInboxLinkProps> = ({ path, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const url = useMemo(() => path ? absoluteUrl(path) : '', [path]);

  if (!path) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className={`sms-publicInboxLink ${compact ? 'is-compact' : ''}`}>
      <div>
        <SmsIcon name="message" />
        <span>
          <strong>Ссылка для доступа к номеру</strong>
          <small>Любой человек со ссылкой сможет видеть SMS, активировать номер и оплатить продление отдельным счётом</small>
        </span>
      </div>
      <div className="sms-publicInboxLink__controls">
        <a href={path} target="_blank" rel="noreferrer" title={url}>{url}</a>
        <button type="button" className="u2-btn is-secondary is-sm" onClick={() => void copy()}>{copied ? 'Скопировано' : 'Копировать'}</button>
      </div>
    </div>
  );
};

export default PublicInboxLink;
